import { useUser } from "@/context/user-context";
import { Report } from "@/types/evaluate";
import { ClipboardCheck } from "lucide-react";
import moment from "moment";
import { Link } from "react-router-dom";

export const BlueprintCard = ({ report }: { report: Report }) => {
  const momentsAgo = moment(report.updated_at).fromNow();
  const userContext = useUser();

  return (
    <Link
      to={`/workspace/${userContext?.activeWorkspaceId}/evaluate/blueprints/${report.id}`}
    >
      <div className="flex h-full items-start gap-2 rounded-lg border border-gray-200 p-4 hover:bg-gray-100">
        <div className="text-md title mt-1 cursor-pointer items-start break-all font-medium group-hover:text-blue-500">
          <ClipboardCheck className="min-h-5 min-w-5 max-w-5 mr-1 max-h-5 text-gray-500" />
        </div>
        <div>
          <h3 className="break-all text-lg font-medium text-gray-900">
            {report.name}
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Last Updated: {momentsAgo}
          </p>
        </div>
        {report.children_report_count > 0 && (
          <div className="min-h-6 min-w-6 my-auto ml-auto flex items-center justify-center rounded-full bg-gray-200 px-2 text-sm font-medium text-gray-800">
            {report.children_report_count}
          </div>
        )}
      </div>
    </Link>
  );
};
